import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { Density } from "./Density";
export var ParticlesNumber = /*#__PURE__*/function () {
  function ParticlesNumber() {
    _classCallCheck(this, ParticlesNumber);
    this.density = new Density();
    this.limit = 0;
    this.value = 100;
  }
  _createClass(ParticlesNumber, [{
    key: "max",
    get: function get() {
      return this.limit;
    },
    set: function set(value) {
      this.limit = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _a;
      if (data === undefined) {
        return;
      }
      this.density.load(data.density);
      var limit = (_a = data.limit) !== null && _a !== void 0 ? _a : data.max;
      if (limit !== undefined) {
        this.limit = limit;
      }
      if (data.value !== undefined) {
        this.value = data.value;
      }
    }
  }]);
  return ParticlesNumber;
}();